
import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';


export const useUser = () => {
  const auth = getAuth();
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  //setLoading(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      setUser(user);
     setUserLoading(false);
    });
    return unsub;
  }, []);

  return { user, userLoading };
  
}

